/*
commonview/view_wrap

this module handles the classnames for the wrapping elements of the depositflow.
It adds and removes classnames when transitions are complete.

usage:
import viewWrap from './view_wrap';
viewWrap.show(myWrapElement);
viewWrap.hide(myWrapElement);
*/
import core from '../../common/lib/core.js';
import constants from '../../common/lib/utils/constants.js';

const classnameOpen = 'slide-in-up';
const classnameClose = 'slide-out-down';
const classnameClose2 = 'u-hide-off-canvas';
const classnameNoTransform = 'u-transform-none'; /* must be added on the wrapper to enable scrolling, which otherwise hides the content with the continue button */
function showWrap(elm) {
	function cancelTransform() {
		core.addClass(elm, classnameNoTransform);
	}
	/* the close- and no-transform may have been added while skipping the steps back and forward and
	have to be removed */
	core.removeClass(elm, classnameNoTransform);
	core.removeClass(elm, classnameClose);
	core.removeClass(elm, classnameClose2);
	core.addClass(elm, classnameOpen);
	/* remove transform when transform is finished to enable scrolling */
	setTimeout(cancelTransform, constants.TRANSITION_DEFAULT_TIME);
}

function hideWrap(elm) {
	/* enable transform before applying classnames dependent on transform
	this is done twice to hack away the postponed execution sometimes
	done by the other timeout above. */
	function extraEnableTransform() {
		core.removeClass(elm, classnameNoTransform);
	}
	core.removeClass(elm, classnameNoTransform);
	core.removeClass(elm, classnameOpen);
	core.addClass(elm, classnameClose);
	core.addClass(elm, classnameClose2);
	/* enable transform when transform is finished to enable scrolling */
	setTimeout(extraEnableTransform, constants.TRANSITION_DEFAULT_TIME);
}

export default {
	show(elm) {
		showWrap(elm);
	},
	hide(elm) {
		hideWrap(elm);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-wrap.js